
<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>chat</mat-icon>
				<span>Chat</span>
			</div>
		
			
			@if( !bApprovalNeeded ) {

				<div class="btnRow">
	
					<button
						mat-raised-button
						color="primary"
						[disabled]="bSending"
						[routerLink]="[ './direktchat' ]"
					>
						<span
							class="material-icons"
							style="vertical-align: text-top; margin-right: .5em"
						>3p</span>
	
						Direktchat
					</button>
	
	
					<button
						mat-raised-button
						color="primary"
						[disabled]="bSending"
						[routerLink]="[ './gruppenchat' ]"
					>
						<span
							class="material-icons"
							style="vertical-align: text-top; margin-right: .5em"
						>group_add</span>
	
						Gruppenchat erstellung
					</button>
	
				</div>

			}

		</div>

		@if( bFirstLoading ) {
			<mat-progress-bar mode="indeterminate" />
		}
		@else if( bFirstLoadingError ) {
			<h4 style="text-align: center; color: red;">
				Beim Laden der Daten ist ein Fehler aufgetreten
			</h4>
		}
		@else if( bApprovalNeeded ) {
			<chat-approval (approved)="bApprovalNeeded = false" />
		}
		@else {

			<div class="hPanel">

				<div
					class="leftPanel"
					[class.leftPanelMaxwidth]="selectedChat"
				>

					<div class="searchDiv">

						<span class="material-icons searchDiv__icon">search</span>
			
						<input
							type="text"
							placeholder="Chat suchen"
							class="searchInput"
							[(ngModel)]="strSearchFilter"
							(input)="chatFilter($event)"
						>

						<span
							class="material-icons iconBtn searchDiv__trigger"
							title="Sortieren"
							[matMenuTriggerFor]="sortMenu"
						>
							filter_list
						</span>

						<mat-menu #sortMenu="matMenu">
							<button 
								mat-menu-item
								(click)="clickChatsSortChrono()"
							>
								Chronologisch
							</button>
							<button 
								mat-menu-item
								(click)="clickSortChatsAlpha()"
							>
								Alphabetisch
							</button>
						</mat-menu>

					</div>

					<div
						class="chatColumn"
						[class.chatColumn--empty]="!chatList.length"
					>

						<div class="chatList" role="list">
							@for( chat of chatList; track chat.id ) {

								<div
									class="chatItem"
									role="listitem"
									[class.chatItem--active]="selectedChat && selectedChat.id == chat.id"
									(click)="toggleMessages(chat)"
								>
									<div class="chatItem__avatar">
										@if( chat.chatType == ChatType.direct ) {
											<span class="chatIconWrapper chatIconWrapper--direct">
												<app-avatar-circle [ebeId]="chat.sourceId" size="md"></app-avatar-circle>
											</span>
										}
										@if( chat.chatType == ChatType.systemGroup ) {
											<span class="chatIconWrapper chatIconWrapper--group">
												<mat-icon>workspaces</mat-icon>
											</span>
										}
										@else if( chat.chatType == ChatType.userGroup ) {
											<span class="chatIconWrapper chatIconWrapper--group">
												<mat-icon>groups</mat-icon>
											</span>
										}
									</div>

									<div class="chatItem__meta">
										<div class="chatItem__header">
											<span
												class="chatItem__title"
												[class.chatItem__title--new]="chat.bNewMsg"
												title="{{chat.title}}"
											>
												{{chat.title}}
											</span>
											@if( chat.lastMsgTmsStr ) {
												<span class="chatItem__timestamp">
													{{chat.lastMsgTmsStr}}
												</span>
											}
										</div>
										<div
											class="chatItem__preview"
											[class.chatItem__preview--new]="chat.bNewMsg"
										>
											{{ chat.lastMsg || "_" }}
										</div>
									</div>
									@if( chat.bNewMsg ) {
										<span class="chatItem__unreadIndicator" aria-hidden="true"></span>
									}
								</div>
							
							}
						</div>

						@if( !chatList.length ) {
							<div class="noElements">
								Kein Chat wurde gefunden
							</div>
						}

						@if( chatCurrentPage || chatMoreResults ) {
							<div class="paginationLine">

								<!--

									can't have a paginator here because the Backend doesn't know exactly how many Chats are going to be available

									<mat-paginator
										#paginator
										(page)="handlePageEvent($event)"
										[disabled]="bInProgress"
										showFirstLastButtons="true"
										hidePageSize="true"
										[length]="chatTotal"
										[pageSize]="10"
										[pageIndex]="chatCurrentPage"
									>
									</mat-paginator>

								-->

								@if( chatPageLoading ) {
									<mat-spinner diameter="32" />
								}
								@else {
									<span
										(click)="switchChatPage(-1)"
										title="Vorherige Chats"
										class="material-icons chatPageIcon"
										[class.iconBtn]="chatCurrentPage"
										[class.iconDisabled]="!chatCurrentPage"
									>
										navigate_before
									</span>
	
									<span
										(click)="switchChatPage(+1)"
										title="NÃ¤chste Chats"
										class="material-icons chatPageIcon"
										[class.iconBtn]="chatMoreResults"
										[class.iconDisabled]="!chatMoreResults"
									>
										navigate_next
									</span>
								}

							</div>
						}

					</div>

				</div>

				@if( selectedChat ) {

					<div @myInsertRemoveTrigger class="rightPanel">

						<div class="chatInfoBar">

							<div class="chatInfoBar__title">
								@if( selectedChat.chatType == ChatType.userGroup ) {
									<span class="chatIconWrapper chatIconWrapper--group">
										<mat-icon>groups</mat-icon>
									</span>
								}
								@else if( selectedChat.chatType == ChatType.systemGroup ) {
									<span class="chatIconWrapper chatIconWrapper--group">
										<mat-icon>workspaces</mat-icon>
									</span>
								}
								<span class="chatInfoBar__name">
									{{ selectedChat.title }}
								</span>
							</div>

							@if( !bSending ) {

								<div class="chatInfoBar__actions">

									<mat-checkbox
										class="chatInfoBar__checkbox"
										[(ngModel)]="bNotifications"
										(input)="onNotificationClick()"
										[disabled]="bNotificationSavingInProgress"
									>
										Benachrichtigungen per E-Mail
									</mat-checkbox>

									@if( selectedChat.chatType == ChatType.userGroup || selectedChat.chatType == ChatType.systemGroup ) {
										<span
											class="material-icons iconBtn chatInfoBar__actionIcon"
											[routerLink]="[ './gruppenchat' ]"
											[queryParams]="{ chat: selectedChat.id, gruppe: selectedChat.sourceId, veranstaltung: (selectedChat.chatType == ChatType.systemGroup) }"
										>
											@if( bChatAdmin ) {
												settings
											}
											@else {
												info
											}
										</span>
									}

								</div>

							}

						</div>
		
						<div class="msgPanel" (scroll)="messagesScrolled($event)">
							
							@if( bLoadingFirstMessages ) {
		
								<div class="spinnerContainer">
									<mat-spinner diameter="160" />
								</div>
		
							}
							@else if( bLoadingMessagesError ) {
		
								<div class="errorWarning errorWarning--center">
									Beim Laden der Daten ist ein Fehler aufgetreten
								</div>
		
							}
							@else if( !selectedChat.messages.length ) {
								
								<div class="noMessages">
									<div class="noMessages__placeholder">
										<span class="material-icons">chat_bubble_outline</span>
										<p>Keine Nachrichten vorhanden. Starte die Unterhaltung.</p>
									</div>
								</div>
		
							}
							@else {
		
								<div class="msgTimeline">

									@if( bLoadingNextMessages ) {
										<mat-spinner class="msgTimeline__loader" diameter="32" />
									}

									@for( message of selectedChat.messages; track message.id ) {
		
										@if( dayDisplay[ message.id ] ) {
											<div class="messageDaySeparator">
												<span class="messageDaySeparator__label">
													{{ dayDisplay[ message.id ] }}
												</span>
											</div>
										}

										<div
											class="chatMessage"
											[class.chatMessage--outgoing]="message.senderId == myUserId"
											[class.chatMessage--incoming]="message.senderId != myUserId"
										>

											<div class="chatMessage__bubble">

												@if( message.msgRepliedToId ) {
													<div
														class="chatMessage__quote txtWrap"
														title="{{message.msgRepliedToTxt}}"
													>
														@if( message.msgRepliedToSenderId != myUserId ) {
															<span class="chatMessage__quoteSender">
																{{ contactNames[ message.msgRepliedToSenderId ] || message.msgRepliedToSenderId }}:
															</span>
														}
														{{message.msgRepliedToTxt}}
													</div>
												}

												@if( message.senderId != myUserId ) {
													<div
														class="chatMessage__sender txtWrap"
														title="{{ contactNames[ message.senderId ] }}"
													>
														{{ contactNames[ message.senderId ] }}
													</div>
												}

												<div class="chatMessage__text">
													@for( line of message.textPerLine; track $index ) {
														<div class="chatMessage__line">
															{{ line }}
														</div>
													}
												</div>

												@if( message.files.length ) {
													<div class="chatMessage__files">
														@for( file of message.files; track file.id ) {
															<div
																class="chatMessage__file txtWrap"
																[title]="file.fileName"
																(click)="clickDownload(file)"
															>
																<span class="material-icons">
																	file_download
																</span>
																<span class="chatMessage__fileName">
																	{{file.fileName}}
																</span>
															</div>
														}
													</div>
												}

											</div>

											<div class="chatMessage__meta">
												<span class="chatMessage__timestamp">
													{{ message.timestamp | date: "HH:mm" }}
												</span>
												<span
													class="material-icons iconBtn chatMessage__reply"
													(click)="clickReplyTo(message)"
													title="Beantworten"
												>reply</span>
											</div>

										</div>
		
									}

								</div>
		
							}
		
						</div>
		
						<div class="inputPanel">
							
							<div class="inputPanel__composer">

								<div class="inputPanel__editor">

								@if( messageBeingRepliedTo ) {
									<div class="messageBeingRepliedTo">
										<div class="senderAndMsg">
											<span class="sender">
												{{ contactNames[ messageBeingRepliedTo.senderId ] ? contactNames[ messageBeingRepliedTo.senderId ] + ': ' : '' }}
											</span>
											<span class="txtWrap">
												{{messageBeingRepliedTo.text}}
											</span>
										</div>
										<span
											class="material-icons iconBtn"
											(click)="cancelReplyTo()"
											title="Abbrechen"
										>
											clear
										</span>
									</div>
								}

								<textarea 
									class="inputPanel__textarea"
									fileDragDrop
									(fileDropped)="onFileDroppedInComponent($event)"
									#textAreaInput
									[(ngModel)]="typedMessage"
									placeholder="Nachricht eingeben"
									(input)="autoGrowTextArea()"
									(keydown)="onKeydownEvent($event)"
									[readonly]="bSending"
								></textarea>

							<input
								type="file"
								hidden
								#fileInput
								[attr.multiple]="true"
								accept="''"
								(change)="onFileInputAdd($event.target)"
							>

							@if( filesToUpload.length ) {

								<div class="filesToUpload">
	
									@for( file of filesToUpload; track file.id ) {
										<div class="fileToUpload">
											<span
												class="txtWrap"
												[title]="file.fileName"
											>
												{{file.fileName}}
											</span>
											<span
												class="material-icons iconBtn"
												(click)="cancelUpload(file.id)"
												title="L&ouml;schen"
											>
												clear
											</span>
										</div>
									}
	
								</div>

							}

								</div>

								<div class="inputPanel__actions">

									<span
										class="material-icons iconBtn inputPanel__icon"
										(click)="fileInput.click()"
										title="Hochladen"
									>
										attach_file
									</span>

									@if( !bSending ) {
										<span
											class="material-icons iconBtn inputPanel__icon"
											(click)="clickSendMessage()"
											title="Senden"
										>
											send
										</span>
									}
									@else {
										<mat-spinner class="inputPanel__spinner" diameter="24" />
									}

								</div>

						</div>

					</div>

						@if( bSendingError ) {
							<div class="saveError">
								<span class="material-icons">error</span>
								Beim Senden der Nachricht ist ein Fehler aufgetreten
							</div>
						}
						@if( bPayloadTooBig ) {
							<div class="saveError">
								<span class="material-icons">error</span>
								Die angehÃ¤ngten Dateien sind zu groÃŸ
							</div>
						}
		
					</div>

				}

			</div>

		}

	</div>

</div>
















